function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { FormLabel as MUIFormLabel } from "@mui/material";
import { useTheme } from "../styles";
const FormLabelForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => {
  const theme = useTheme();
  const formLabelStyles = {
    transform: "unset",
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    "&.Mui-focused": {
      color: theme.palette.text.secondary
    },
    "&.Mui-disabled": {
      color: theme.palette.text.secondary
    },
    "&.Mui-error": {
      color: theme.palette.error.main
    }
  };
  return /*#__PURE__*/React.createElement(MUIFormLabel, _extends({
    sx: formLabelStyles
  }, props, {
    ref: ref
  }));
});
export const FormLabel = props => /*#__PURE__*/React.createElement(FormLabelForwardRef, props);
export default FormLabel;